import { Box, Divider } from "@bcc-ui/ui-components";
import React from "react";

import style from "./navigation-divider.scss";

export const NavigationDivider = () => {
    return (
        <Box columnLayout className={style.navigationDivider}>
            <Divider />
        </Box>
    );
};
